import React from "react";

import styles from "./Info.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import { SELLER } from "../../../../config/legal";

const Info: React.FC = () => {
  return (
    <section className={styles.info}>
      <div className="container">
        <PreviousPage currentPage="Политика обработки персональных данных" title="Обработка персональных данных" />
        <p className={styles.text}>
          Настоящая Политика обработки персональных данных (далее – Политика) действует в отношении всей информации, которую
          интернет-магазин, расположенный на доменном имени {SELLER.site}, в лице {SELLER.name}, ИНН {SELLER.inn}, ОГРНИП{" "}
          {SELLER.ogrnip}, юридический адрес: {SELLER.address} (далее – Оператор), может получить о любом лице (далее – Субъект)
          во время использования сайта.
        </p>
        <ul className={styles.list}>
          <h3>1. Определение терминов</h3>
          <ol>
            1.1.1. «Администрация сайта» – Оператор или уполномоченные сотрудники, действующие от имени Оператора, которые
            организуют обработку персональных данных, определяют цели, состав данных и действия с ними.
          </ol>
          <ol>
            1.1.2. «Персональные данные» – любая информация, относящаяся к прямо или косвенно определённому или определяемому
            физическому лицу.
          </ol>
          <ol>
            1.1.3. «Обработка персональных данных» – любое действие или совокупность действий с персональными данными, включая
            сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание,
            блокирование, удаление и уничтожение.
          </ol>
          <ol>
            1.1.4. «Cookies» – небольшой фрагмент данных, который сайт сохраняет на устройстве пользователя и получает при
            повторных обращениях.
          </ol>
          <ol>1.1.5. «IP-адрес» – сетевой адрес устройства в сети, построенной по протоколу IP.</ol>

          <h3>2. Общие положения</h3>
          <ol>
            2.1. Использование сайта означает, что Субъект ознакомился с настоящей Политикой. Само по себе посещение сайта не
            является согласием на обработку персональных данных.
          </ol>
          <ol>
            2.2. Обработка персональных данных осуществляется только при наличии согласия, выраженного активно и явно: отметкой в
            чекбоксе «Согласен(а) с политикой обработки персональных данных» и отправкой соответствующей формы. Согласие
            оформляется отдельно, не проставляется заранее и не считается данным по умолчанию.
          </ol>
          <ol>
            2.3. При несогласии с Политикой Субъект должен прекратить использование сайта и не отправлять формы, в которых
            запрашиваются персональные данные.
          </ol>
          <ol>
            2.4. Политика применяется только к сайту {SELLER.site}. Оператор не контролирует сайты третьих лиц, на которые
            Субъект может перейти по ссылкам.
          </ol>

          <h3>3. Какие данные обрабатываются</h3>
          <ol>
            3.1. Политика устанавливает обязанности Администрации по защите персональных данных, которые Субъект сообщает при
            регистрации, оформлении заказа, оплате, заполнении анкеты для молодых дизайнеров, анкеты для предоставления образцов и
            обращений через формы сайта.
          </ol>
          <ol>3.2. В формах могут запрашиваться:</ol>
          <ol>3.2.1. фамилия, имя, отчество (или по отдельности);</ol>
          <ol>3.2.2. контактный телефон;</ol>
          <ol>3.2.3. адрес электронной почты;</ol>
          <ol>3.2.4. адрес доставки товара;</ol>
          <ol>
            3.2.5. сведения, которые Субъект сам указывает в анкете дизайнера или в заявке на образцы (город, сведения о
            деятельности, ссылки, наименование организации, ИНН, состав запроса). Такие сведения используются только для
            рассмотрения соответствующей заявки.
          </ol>
          <ol>
            3.3. Аналитические файлы cookie, в том числе счётчик веб-аналитики, подключаются только после нажатия кнопки
            «Принять» в уведомлении об использовании cookie. До этого сторонние сервисы аналитики не загружаются. Кнопка
            «Отказаться» означает отказ от аналитических cookie, сайт при этом продолжает работать. Необходимые cookie для работы
            страниц могут использоваться без этого согласия.
          </ol>
          <ol>
            3.3.1. При согласии на аналитические cookie могут обрабатываться IP-адрес, сведения из cookie, данные браузера и
            операционной системы, дата и время доступа, адрес страницы, адрес предыдущей страницы и сведения о действиях на
            сайте. Цель – статистика посещаемости и улучшение работы сайта.
          </ol>
          <ol>
            3.3.2. Субъект может ограничить cookie в настройках браузера. Отключение cookie может затруднить доступ к разделам,
            требующим авторизации.
          </ol>
          <ol>
            3.4. Иная информация (история заказов, технические данные об устройстве) хранится и не распространяется, кроме случаев,
            указанных в разделах 5.3 и 5.4.
          </ol>

          <h3>4. Цели обработки</h3>
          <ol>4.1. Персональные данные могут использоваться для:</ol>
          <ol>4.1.1. идентификации Субъекта, оформления заказа и заключения договора купли-продажи дистанционным способом;</ol>
          <ol>4.1.2. доступа к персонализированным разделам сайта;</ol>
          <ol>4.1.3. обратной связи, уведомлений о заказе и обработки обращений;</ol>
          <ol>4.1.4. приёма платежей;</ol>
          <ol>4.1.5. клиентской поддержки;</ol>
          <ol>4.1.6. информационных и рекламных сообщений – только при отдельном согласии Субъекта;</ol>
          <ol>4.1.7. рассмотрения анкеты дизайнера или заявки на образцы.</ol>

          <h3>5. Сроки, место и передача</h3>
          <ol>
            5.1. Данные хранятся не дольше, чем это нужно для целей обработки, либо до отзыва согласия, если закон не требует
            более долгого хранения.
          </ol>
          <ol>5.1.1. Ориентиры сроков:</ol>
          <ol>
            данные заказа и договора – в течение срока договора и 5 лет после окончания календарного года, в котором договор
            исполнен (бухгалтерский и налоговый учёт);
          </ol>
          <ol>данные учётной записи – до удаления записи или отзыва согласия;</ol>
          <ol>данные для рассылок – до отзыва согласия на такие сообщения;</ol>
          <ol>аналитические данные – не дольше, чем нужно для заявленных целей, и только при согласии на аналитические cookie;</ol>
          <ol>
            данные анкет – до исполнения или отказа по заявке и 3 лет после этого либо до отзыва согласия; при оплате – также в
            сроки бухгалтерского учёта.
          </ol>
          <ol>
            5.2. Запись, систематизация, накопление, хранение, уточнение и извлечение персональных данных граждан Российской
            Федерации с использованием баз данных осуществляются на территории Российской Федерации (часть 5 статьи 18 Федерального
            закона от 27.07.2006 № 152-ФЗ).
          </ol>
          <ol>
            5.3. Оператор может передать данные курьерским и почтовым службам и операторам связи – только для исполнения заказа, а
            также АО «ТБанк» – в объёме, необходимом для проведения платежа на платёжном шлюзе банка. Реквизиты банковской карты
            вводятся на стороне банка и Оператору не передаются.
          </ol>
          <ol>
            5.4. Передача уполномоченным государственным органам Российской Федерации возможна только по основаниям и в порядке,
            установленным законодательством.
          </ol>
          <ol>5.5. При утрате или разглашении персональных данных Администрация сообщает об этом Субъекту.</ol>
          <ol>
            5.6. Администрация принимает организационные и технические меры против неправомерного доступа, уничтожения, изменения,
            блокирования, копирования и распространения данных.
          </ol>

          <h3>6. Права и обязанности</h3>
          <h4>6.1. Субъект обязан</h4>
          <ol>сообщать достоверные данные, необходимые для заказа и обращений, и обновлять их при изменении.</ol>
          <h4>6.2. Субъект вправе</h4>
          <ol>
            получить сведения о своих данных, потребовать их уточнения, блокирования или удаления, отозвать согласие на обработку
            и на рекламные сообщения, а также обжаловать действия Оператора в уполномоченный орган по защите прав субъектов
            персональных данных или в суд. Запрос направляется по юридическому адресу Оператора: {SELLER.address}. В запросе
            указываются ФИО, телефон или адрес электронной почты, по которым можно идентифицировать заявителя.
          </ol>
          <h4>6.3. Администрация обязана</h4>
          <ol>
            использовать данные только для целей этой Политики, не продавать и не раскрывать их, кроме пунктов 5.3 и 5.4, и
            блокировать данные на время проверки при обращении Субъекта или уполномоченного органа.
          </ol>

          <h3>7. Ответственность</h3>
          <ol>
            7.1. Администрация несёт ответственность за нарушение законодательства Российской Федерации о персональных данных в
            пределах, установленных законом.
          </ol>
          <ol>
            7.2. Администрация не отвечает за разглашение, если сведения стали общедоступными до утраты, получены от третьего лица
            до передачи Оператору либо раскрыты с согласия Субъекта.
          </ol>

          <h3>8. Изменение Политики</h3>
          <ol>8.1. Оператор вправе изменить Политику. Новая редакция действует с момента размещения на сайте, если в ней не указано иное.</ol>
          <ol>
            8.2. Вопросы по Политике направляются {SELLER.shortName} по адресу: {SELLER.address}. Сайт: {SELLER.siteUrl}
          </ol>
        </ul>
      </div>
    </section>
  );
};

export default Info;
